import React from "react";
import ImageUpload from "../../../../common/image-upload";
import TextField from "../../../../common/text-field/TextField";
import SelectField from "../../../../common/select/SelectField";
import {
  bloodGroupOptions,
  genderOptions,
  maritalStatusOptions,
  yesNoOption,
} from "../../../../../constants/constants";
import DatePickerField from "../../../../common/date-picker/DatePicker";
const today = new Date();
const maxDobDate = new Date(
  today.getFullYear() - 18,
  today.getMonth(),
  today.getDate(),
);

interface PersonalDetailsProps {
  formData: any;
  errors: any;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => void;
  handleFileChange: (file: File | null, name: string) => void;
  handleDateChange: (name: "dob", value: string) => void;
}

const PersonalDetails = ({
  formData,
  errors,
  handleChange,
  handleFileChange,
  handleDateChange,
}: PersonalDetailsProps) => {
  return (
    <div className="bg-transparent p-1 sm:p-4">
      <h2 className="text-xl text-white font-medium mb-6 border-b pb-3">
        Personal Details
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 bg-white p-4">
        {/* Employee Photo */}
        <ImageUpload
          name="employeePhoto"
          onChange={(file) => handleFileChange(file, "employeePhoto")}
          error={errors.employeePhoto}
          label={"Employee Picture"}
          required
        />

        <div />

        <div />

        {/* First Name */}
        <TextField
          label="First Name"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          error={errors.firstName}
          placeholder="Enter First Name"
          required
        />

        {/* Last Name */}
        <TextField
          label="Last Name"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          error={errors.lastName}
          placeholder="Enter Last Name"
          required
        />

        {/* DOB */}
        <DatePickerField
          label="Date of Birth"
          name="dob"
          value={formData.dob}
          error={errors.dob}
          onChange={(date: string): void => handleDateChange("dob", date)}
          maxDate={maxDobDate}
          required
        />

        {/* Email */}
        <TextField
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          error={errors.email}
          placeholder="Enter Email"
          required
        />

        {/* Phone */}
        <TextField
          label="Phone"
          name="phone"
          type="number"
          value={formData.phone}
          onChange={handleChange}
          error={errors.phone}
          placeholder="Enter Phone No."
          required
        />

        {/* Alternate Phone */}
        <TextField
          label="Alternate Phone"
          name="alternatePhone"
          type="number"
          value={formData.alternatePhone}
          onChange={handleChange}
          error={errors.alternatePhone}
          placeholder="Enter Alternate Phone No."
        />

        {/* Gender */}
        <SelectField
          name="gender"
          label="Gender"
          options={genderOptions}
          value={
            formData.gender
              ? (genderOptions.find((ele) => ele.value === formData.gender) ??
                "")
              : ""
          }
          placeholder="Select Gender"
          error={errors.gender}
          onChange={(option) =>
            handleChange({
              target: { name: "gender", value: option?.value },
            } as React.ChangeEvent<HTMLInputElement | HTMLSelectElement>)
          }
        />

        {/* Blood Group */}
        <SelectField
          name="bloodGroup"
          label="Blood Group"
          options={bloodGroupOptions}
          value={
            formData.bloodGroup
              ? (bloodGroupOptions.find(
                  (ele) => ele.value === formData.bloodGroup,
                ) ?? "")
              : ""
          }
          placeholder="Select Blood Group"
          error={errors.bloodGroup}
          onChange={(option) =>
            handleChange({
              target: { name: "bloodGroup", value: option?.value },
            } as React.ChangeEvent<HTMLInputElement | HTMLSelectElement>)
          }
        />

        {/* Marital Status */}
        <SelectField
          name="isMarried"
          label="Marital Status"
          options={maritalStatusOptions}
          value={
            formData.isMarried
              ? (maritalStatusOptions.find(
                  (ele) => ele.value === formData.isMarried,
                ) ?? "")
              : ""
          }
          placeholder="Select Marital Status"
          error={errors.isMarried}
          onChange={(option) =>
            handleChange({
              target: { name: "isMarried", value: option?.value },
            } as React.ChangeEvent<HTMLInputElement | HTMLSelectElement>)
          }
          required
        />

        {/* Physically Disabled */}
        <SelectField
          name="isPhysicallyDisabled"
          label="Physically Disabled"
          options={yesNoOption}
          value={
            formData.isPhysicallyDisabled
              ? (yesNoOption.find(
                  (ele) => ele.value === formData.isPhysicallyDisabled,
                ) ?? "")
              : ""
          }
          placeholder="Select Physically Disabled"
          error={errors.isPhysicallyDisabled}
          onChange={(option) =>
            handleChange({
              target: { name: "isPhysicallyDisabled", value: option?.value },
            } as React.ChangeEvent<HTMLInputElement | HTMLSelectElement>)
          }
          required
        />
      </div>
    </div>
  );
};

export default PersonalDetails;
